import type { OverviewDataPayload } from "@shared/types/overview";

import { apiClient } from "./apiClient";

/**
 * Fetch the overview dashboard payload for the authenticated user.
 *
 * The endpoint is per-user on the backend (admins see platform aggregates,
 * other users see their own data). Errors are intentionally propagated to
 * the caller so React Query can surface them through `isError`; the UI
 * component already renders a retry card. Do NOT fall back to mock data
 * here - silent mock fallbacks hide real integration failures from users
 * and operators.
 *
 * Contract: `@shared/types/overview.OverviewDataPayload`.
 * Endpoint: `GET /dashboard/overview/` (trailing slash required to avoid
 * the 307 redirect that trips the browser CSP).
 */
export async function fetchOverviewData(): Promise<OverviewDataPayload> {
  const response = await apiClient.get<OverviewDataPayload>(
    "/dashboard/overview/",
  );
  return response.data;
}

